import NotificationSettingsDealClosingInterval from "@app/enum/NotificationSettingsDealClosingInterval";
import NotificationSettingsRecordUpdateItem from "@app/types/notifications/NotificationSettingsRecordUpdateItem";

import getRecordOwnershipDealLevelSettingsState from "./getRecordOwnershipDealLevelSettingsState";

const getRecordOwnershipLevelSettingsState = (
  enabled: boolean
): NotificationSettingsRecordUpdateItem => ({
  dealsClosing: { enabled, interval: NotificationSettingsDealClosingInterval.DAY },
  dealStages: getRecordOwnershipDealLevelSettingsState(enabled),
  enabled,
  outOfCadence: enabled,
  overdueActivities: enabled,
  rottedDeals: enabled,
});

export default getRecordOwnershipLevelSettingsState;
